import { Context, useContext } from 'react';
import { ModuleFeatureContext, ModuleFeatureContextType } from '../context/ModuleFeatureContext';

export const useModuleFeature = () => {
    return useContext<ModuleFeatureContextType>(
        ModuleFeatureContext as Context<ModuleFeatureContextType>
    );
};
